import React, { useState } from "react";
import Header from "../components/Header";
import AuthModal from "../components/AuthModal";
import DocumentsModal from "../components/DocumentsModal";
import { useAuth } from "../utilities/auth";
import { Redirect } from "react-router-dom";
import { applyLoginDefaultChampId } from "../utilities/championships";
import { firstAllowedPath } from "../utilities/adminAccess";
import FirstSlide from "../components/FirstSlide";

function Main() {
  const [modalVisible, setModalVisible] = useState(false);
  const [documentsModalVisible, setDocumentsModalVisible] = useState(false);
  const { userData, setUserData } = useAuth();

  const toggleModal = () => setModalVisible((prev) => !prev);
  const toggleDocumentsModal = () => setDocumentsModalVisible((prev) => !prev);

  const openDocumentsFromAuth = () => {
    setModalVisible(false);
    setDocumentsModalVisible(true);
  };

  const handleAuthSuccess = (session) => {
    applyLoginDefaultChampId(session);
    setUserData(session);
  };

  if (userData) {
    const nextPath = firstAllowedPath(userData);
    if (nextPath && nextPath !== '/') {
      return <Redirect to={nextPath} />;
    }
  }

  return (
    <div className="allapp">
      <Header
        toggleModal={toggleModal}
        setCurrentPage={() => {}}
      />
      <AuthModal
        visible={modalVisible}
        closeModal={toggleModal}
        onSuccess={handleAuthSuccess}
        openDocuments={openDocumentsFromAuth}
      />
      <DocumentsModal
        visible={documentsModalVisible}
        closeModal={toggleDocumentsModal}
      />
      <FirstSlide onLoginClick={toggleModal} />
    </div>
  );
}

export default Main;
